import React, { lazy } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import reportWebVitals from "./reportWebVitals";
import LandingRoute from "./LandingRoute";
import OneToManyCallScreen from "./screens/OneToManyCallScreen";
import PodcastScreen from "./screens/PodcastScreen";
const App = lazy(() => import("./App"));

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
const path = window.location.pathname;

root.render(
  <BrowserRouter>
    {path.includes("/landing") ? (
      <LandingRoute />
    ) : path.includes("/otmmeeting") ? (
      <OneToManyCallScreen />
    ) : path.includes("/podcastmeeting") ? (
      <PodcastScreen />
    ) : (
      <App />
    )}
  </BrowserRouter>
);
reportWebVitals();
